import { isValidEmailAddress, fadeOutNotifications, groupBy } from '../functions';

$(document).ready(function() {

	const experts = {
        isLoading: false,
		experts: [],
        init() {
			const _this = this;

			let selectBoxes = document.querySelectorAll('.select-pricing');
			selectBoxes.forEach(selectBox => $(selectBox).ulSelect(function(selectedLI) {
				_this.selectedExperts();
			}));

			$(document).on('click', '.unselect-expert', this, this.unselectExpert);
			$(document).on('click', '#experts-send-modal-btn', this, this.form);
			$(document).on('click', '#experts-send-btn', this, this.send);
        },
		selectedExperts() {
			var experts = [];
			$('.expert-experience').each(function(index, element) {
				var id = $(element).data('id');
				var category = $(element).data('category');
				var name = $(element).data('name');

				var years = $('#expert-experience-' + id).find('.active').data('years');
				var price = $('#expert-experience-' + id).find('.active').data('price');
				var hours = $('#expert-hours-' + id).find('.active').data('hours');
				if (years != '' && hours != '') {
					var expert = {
						id: id,
						category: category,
						name: name,
						years: years,
						hours: hours,
						price: price,
					};
					experts[id] = expert;

					var cost = price*hours;
					$('#selected-expert-wrapper-' + id).find('span').text(cost);
					$('#selected-expert-wrapper-' + id).show();
				} else {
					//delete experts[id];
					experts = experts.filter(function(obj) {
					    return obj.id !== id;
					});
					$('#selected-expert-wrapper-' + id).find('span').text('');
					$('#selected-expert-wrapper-' + id).hide();
				}
			}, experts);

			experts = experts.filter(function(obj) {
				return true;
				//return obj.id !== id;
			});

			var expertsGrouped = groupBy(experts, 'category');
			this.experts = experts;

			//console.log(experts.length);

			$('.selected-experts-container').hide();
			$('.selected-experts-wrapper').html('');
			$('.total-wrapper').html('');

			if (experts.length > 0) {

				var total = 0;

				var html = ``;
				var ctrCateg = 0;
				for(var i in expertsGrouped) {
					ctrCateg++;
					var categoryHtml = `<div class="col-12 mt-2 text-md-left">
						<div class="cell pl-md-4">
							<h6 class="font-weight-bold">${i}</h6>
						</div>
					</div>`;

					var innerHtml = ``;
					var ctr = 0;
					for (var e in expertsGrouped[i]) {
						ctr++;
						if (ctr > 1) {
							categoryHtml = '';
						}

						var cost = expertsGrouped[i][e].price * expertsGrouped[i][e].hours;
						total += cost;
						var rowClass = ctr % 2 == 0 ? 'bg-light' : '';

						innerHtml += `<div class="row ${rowClass}">
	                        ${categoryHtml}
	                        <div class="col-md-4 text-md-left">
	                            <div class="cell pl-md-4">
	                                <h6>${expertsGrouped[i][e].name}</h6>
	                            </div>
	                        </div>
	                        <div class="col-md-3 text-left text-md-center">
	                            <div class="cell">
	                                <h6>${expertsGrouped[i][e].years}+ ${EXPERTS_ANI_EXPERIENTA}</h6>
	                            </div>
	                        </div>
	                        <div class="col-md-3 text-left text-md-center">
	                            <div class="cell">
	                                <h6>${expertsGrouped[i][e].hours} ${EXPERTS_ORE_LUNAR}</h6>
	                            </div>
	                        </div>
	                        <div class="col-md-2 text-left text-md-center">
	                            <div class="cell">
	                                <h6 class="font-weight-bold">${cost} euro + ${EXPERTS_TVA}</h6>
	                            </div>
	                        </div>
	                    </div>`;
					}

					var hr = '';
					if(ctrCateg > 1) {
						hr = `<hr class="mb-0">`;
					}

					html += `${hr}<div class="table-body">
						${innerHtml}
					</div>`;
				}

				$('.selected-experts-wrapper').html(html);
				$('.total-wrapper').text(total + ' euro + ' + EXPERTS_TVA);
				$('.selected-experts-container').show();
			}

			//console.log(experts);
		},
		unselectExpert(event) {
			const _this = event.data;

			var id = $(this).data('id');

			$('#expert-experience-' + id + ' li').removeClass('active');
			$('#expert-hours-' + id + ' li').removeClass('active');
			$('#expert-experience-' + id).find('.empty').addClass('active');
			$('#expert-hours-' + id).find('.empty').addClass('active');

			_this.selectedExperts();
		},
		form(event) {
			const _this = event.data;

			if (_this.experts.length < 1) {
				Swal.fire({
					//icon: "success",
					//title: "Eroare!",
					html: EXPERTS_EMPTY_MSG
				});
				return;
			}

			$('#experts-modal-form').find('.form-control').val('');
			$('#expert_form_terms').attr('checked', false);

			$('#experts-modal-form').modal('show');
		},
		send(event) {
			const _this = event.data;

			if (_this.isLoading) {
	            console.log('is loading...');
	            return false;
	        }

			if (_this.experts.length < 1) {
				Swal.fire({
					//icon: "success",
					//title: "Eroare!",
					html: EXPERTS_EMPTY_MSG
				});
				return;
			}

			var error = false;
			$('.experts-modal-form').find('.form-control').removeClass('is-invalid');
			$('.experts-modal-form').find('.form-check-input').removeClass('is-invalid');

			if ($('#expert_form_first_name').val() == '') {
				$('#expert_form_first_name').addClass('is-invalid');
				error = true;
			}
			if ($('#expert_form_email').val() == '') {
				$('#expert_form_email').addClass('is-invalid');
				error = true;
			}
			if ($('#expert_form_brand').val() == '') {
				$('#expert_form_brand').addClass('is-invalid');
				error = true;
			}
			if ($('#expert_form_message').val() == '') {
				$('#expert_form_message').addClass('is-invalid');
				error = true;
			}
			if (!$('#expert_form_terms').is(':checked')) {
				$('#expert_form_terms').addClass('is-invalid');
				error = true;
			}
			if (error) {
				return false;
			}

			_this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'first_name=' + $('#expert_form_first_name').val();
			values += '&email=' + $('#expert_form_email').val();
			values += '&phone=' + $('#expert_form_phone').val();
			values += '&brand=' + $('#expert_form_brand').val();
			values += '&budget=' + $('#expert_form_budget').val();
			values += '&website_url=' + $('#expert_form_website_url').val();
			values += '&message=' + $('#expert_form_message').val();
			values += '&experts=' + encodeURIComponent(JSON.stringify(_this.experts));
			values += '&type=1';
			values += '&module_id=' + $(element).data('mid');
			values += '&_token=' + $("meta[name='csrf-token']").attr("content");
	        $.ajax({
	            type: "POST",
	            url: baseURL + "/contact/send",
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
						var errorHtml = '';
						for(var errorKey in response.errors) {
							if(!response.errors.hasOwnProperty(errorKey)) continue;
							for(var error in response.errors[errorKey]) {
								$("#expert_form_"+errorKey).addClass('is-invalid');
								errorHtml += response.errors[errorKey][error] + '<br>';
							}
						}

						//$('#bookings-form-error-msg').html(errorHtml);
                        //$('#bookings-form-error-msg').fadeIn();
						Swal.fire({
							//icon: "success",
							title: "Eroare!",
							html: errorHtml
						});
						return false;
					}

					if (response.status == 1) {
						$('.expert-experience').find('li').removeClass('active');
						$('.expert-hours').find('li').removeClass('active');
						$('.expert-experience').find('.empty').addClass('active');
						$('.expert-hours').find('.empty').addClass('active');

						_this.selectedExperts();

						$('#experts-modal-form').modal('hide');
						$('#experts-modal-form').on('hidden.bs.modal', function() {
							$('#experts-modal-form').find('.form-control').val('');
							$('#expert_form_terms').attr('checked', false);

							Swal.fire({
								html: response.message
							});
						});
						return;
					}
	            },
				error(error) {
					_this.isLoading = false;
					$(element).find('i').hide();
				}
	        });
		},
	};
    experts.init();
});



// WEBPACK FOOTER //
// ./resources/js/modules/experts.js